/** --------------------------------------------------
*
*   paragraphs
*   PARAGRAPH: QUICKLINKS
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.paragraph_quicklinks = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      if (!once('paragraph_quicklinks', 'html').length) {
        return;
      }
      self.init(context, settings);
    },

    init: function(context, settings) {

      // observe all "quicklinks" paragraphs
      // to toggle attributes based on the height of the paragraph:
      // -> background decorations are only possible if the paragraph
      //    has a certain height (to prevent styling issues)
      if (window.ResizeObserver) {

        const quicklinksParagraphs = document.querySelectorAll('.js-p-quicklinks');
        quicklinksParagraphs.forEach(function(quicklinksParagraph) {

          const ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const paragraphHeight = entry.contentRect.height;

              if(paragraphHeight > 520) {
                quicklinksParagraph.setAttribute('data-decoration-is-possible', 'true');
              } else {
                quicklinksParagraph.setAttribute('data-decoration-is-possible', 'false');
              }

              if(paragraphHeight > 1040) {
                quicklinksParagraph.setAttribute('data-large-decoration-is-possible', 'true');
              } else {
                quicklinksParagraph.setAttribute('data-large-decoration-is-possible', 'false');
              }
            }
          });

          ro.observe(quicklinksParagraph);
        });
      }
    }
  };
})(Drupal, once, window.duo = window.duo || {});
